import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/config';
import { TokenService } from 'src/app/core/services/token.service';
import { MaterialModule } from 'src/app/material.module';
import { CoreService } from 'src/app/shared/services/core.service';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { navItems } from '../sidebar/sidebar-data';
@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  isCollapse: boolean = false; // Initially hidden
  savedLang: any;

  toggleCollpase() {
    this.isCollapse = !this.isCollapse; // Toggle visibility
  }

  showFiller = false;

  public selectedLanguage: any;

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'العربية',
      code: 'ar',
      icon: '/assets/images/flag/saudi-arabia-flag-icon.svg',
    },
  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();
  loading: boolean = false;
  userId: number;
  userTypeId: number;
  userInfo: any = null;
  imageBaseUrl = environment.imageBaseUrl;
  photo = './assets/images/sensor.png';
  userType: string | undefined;
  userName: any = null;
  constructor(
    private settings: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private tokenService: TokenService,
  ) {
    this.userId = this.tokenService.getUserIdFromToken();
    this.userTypeId = this.tokenService.getUserTypeIdFromToken();


    translate.setDefaultLang('ar');
    this.savedLang = localStorage.getItem('lang');
    if (this.savedLang != undefined) {
      this.selectedLanguage = JSON.parse(this.savedLang);
      this.translate.use(this.selectedLanguage.code && ['en', 'ar'].includes(this.selectedLanguage.code) ? this.selectedLanguage.code : 'ar');
    } else {
      this.selectedLanguage = this.languages[1];
    }
    this.options().dir = this.selectedLanguage.code === 'ar' ? 'rtl' : 'ltr'

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme != undefined) {
      this.options().theme = savedTheme
      this.settings.setOptions({ theme: savedTheme });
      this.emitOptions();
    } else {
      this.options().theme = 'light'
      this.settings.setOptions({ theme: 'light' });
      this.emitOptions();
    }

  }

  ngOnInit(): void {
    this.getUserInfo(this.userTypeId);
  }


  // Logout functionality
  logout() {
    this.loading = true; // Start loading

    try {
      this.authService.logout();
    } catch (err) {
    } finally {
      this.loading = false; // Stop loading
    }
  }

  // Define the mapping of userTypeId to userType string
  private userTypeMap: { [key: number]: string } = {
    1: 'participate',
    2: 'employee',
    3: 'judge' 
  };

  getUserInfo(userTypeId: number) {
    let controllerRoute = '';

    if (!this.userId) {
      console.error('User ID is not available');
      return;
    }

    // استخرج نوع المستخدم من الخريطة
    let userType = this.userTypeMap[userTypeId];

    if (!userType) {
      console.error('Invalid user type ID:', userTypeId);
      return;
    }

    if (userType === 'judge') {
      controllerRoute = 'participate';
    }
    else
      controllerRoute = userType;

    // Set the userType to display in the template
    this.userType = userType;
    // Fetch user info based on the dynamic user type
    this.authService.getInfoByUserId(controllerRoute, this.userId).subscribe(
      (response) => {
        console.log(this.userType);
        this.userInfo = response.data;
        const currentLang = this.translate.currentLang || this.selectedLanguage?.code || 'en';

        const getFullName = (first?: string, last?: string): string => {
          return [first, last].filter(Boolean).join(" ").trim();
        };

        const enName = getFullName(this.userInfo.firstNameEn, this.userInfo.lastNameEn);
        const arName = getFullName(this.userInfo.firstNameAr, this.userInfo.lastNameAr);
        const email = this.userInfo.email;

        if (currentLang === 'ar') {
          this.userName = arName || enName || '';
        } else {
          this.userName = enName || arName || '';
        }
      },
      (error) => {
        // console.error('Failed to fetch user info', error);
      }
    );
  }

  readonly options = this.settings.optionsSignal;


  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      // console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang);
    localStorage.setItem('lang', JSON.stringify(lang));
    this.selectedLanguage = lang
    window.location.reload()
  }

  setlightDark(theme: string) {
    this.options().theme = theme
    localStorage.setItem('theme', theme);
    this.settings.setOptions({ theme: theme });
    this.emitOptions();
  }



  private emitOptions() {
    this.optionsChange.emit(this.options());
  }

}

@Component({
  selector: 'search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

}
